module.exports = __webpack_public_path__ + "static/media/check.5c64310d.svg";